<div class="registration-success">
  <div class="success-content">
    <img src="assets/done.png" alt="Success" class="success-icon"/>
    <h2>✨ Your profile is ready!</h2>
    <p class="text">You've completed your registration and your CV has been successfully processed.</p>
    <p class="text">You can now explore jobs, and start applying!</p>
  </div>

  <div class="action-buttons">
    <app-button [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR"
                [label]="'Go to My Profile'"
                [type]="ButtonType.SECONDARY"
                (click)="goToProfile()"
                class="secondary-button">
    </app-button>

    <app-button [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR"
                [label]="'Search Jobs 🚀'"
                [type]="ButtonType.PRIMARY"
                (click)="goToMain()"
                class="primary-button">
    </app-button>
  </div>
</div>
